/*global VeloxWebView*/


var extension = {} ;
extension.name = "algae-field" ;

//must run after fields
extension.mustRunAfter = ["fields", "country"] ;

var COUNTRY_AVAILABILITY = {
    "STABICHLORAN"     : { FR: true, DE: false, ES: false, GB: false},  
    "NOPHOS" :           { FR: true, DE: true, ES: false, GB: false}
};


function computeOptions(){
    return Object.keys(COUNTRY_AVAILABILITY).filter(function(p){
        //filter by country availability
        return COUNTRY_AVAILABILITY[p][VeloxWebView.country.get()] ;
    }).map(function(p){
        return {
            id: p,
            label: VeloxWebView.tr("fields.values.pool.p_advanced_other."+p)
        } ;
    });
}

extension.init = function(){
    var view = this ;
    view.on("initDone", function(){
        var advOtherEl = view.viewRootEl.querySelector('[data-field-def="pool.p_advanced_other"]');
        if(!advOtherEl){
            advOtherEl = view.viewRootEl.querySelector('[data-field-def="diag.p_advanced_other"]');
        }
        if(advOtherEl){
            view.on("render", function(){
                var options = computeOptions();
                advOtherEl.setOptions(options) ;
                if(options.length === 0){
                    advOtherEl.style.display = "none" ;
                }else{
                    advOtherEl.style.display = "block" ;
                }
            }) ;
        }   
    }) ;
} ;




module.exports = extension ;